import { FETCH_ADDRESS } from '../white_list/action_types';
import {
  FETCH_COMMISSION,
  FETCH_COMMISSION_SUCCESS,
  FETCH_COMMISSION_FAIL,
  FETCH_COMMISSION_BY_TIME,
  FETCH_COMMISSION_BY_TIME_SUCCESS,
  FETCH_COMMISSION_BY_TIME_FAIL,
} from './action_types';

export default {
  FetchCommission: () => ({
    type: FETCH_COMMISSION,
  }),
  onFetchCommissionSuccess: (data) => ({
    type: FETCH_COMMISSION_SUCCESS,
    data,
  }),
  onFetchCommissionFail: () => ({
    type: FETCH_COMMISSION_FAIL,
  }),
  FetchCommissionRange: (data) => ({
    type: FETCH_COMMISSION_BY_TIME,
    data,
  }),
  onFetchCommissionRangeSuccess: (data) => ({
    type: FETCH_COMMISSION_BY_TIME_SUCCESS,
    data,
  }),
  onFetchCommissionRangeFail: () => ({
    type: FETCH_COMMISSION_BY_TIME_FAIL,
  }),
};
